module.exports = __webpack_public_path__ + "static/media/jug.5effc7f2.svg";